import Glide from '@glidejs/glide';

export function initSimilarProductsCarousel() {
    const carouselSimilar = document.querySelectorAll('.product-slider-similar-products');

    if (!carouselSimilar) {
        return;
    }

    carouselSimilar.forEach((element) => {
        const slidesPhysicalCount = element.querySelectorAll('.glide__slide').length;

        const perViewHandled = (items) => (items <= slidesPhysicalCount ? items : slidesPhysicalCount);

        const toggleArrows = () => {
            if (productSlider.settings.perView < slidesPhysicalCount) {
                element.querySelector('.product-slider .product-slider__arrows').classList.remove('d-none');
            } else {
                element.querySelector('.product-slider .product-slider__arrows').classList.add('d-none');
            }
        };

        // eslint-disable-next-line no-unused-vars
        const isDragable = () => {};

        const productSlider = new Glide(element, {
            autoplay: false,
            perView: perViewHandled(4),
            breakpoints: {
                1200: {
                    perView: perViewHandled(4),
                },
                992: {
                    perView: perViewHandled(3),
                },
                768: {
                    perView: perViewHandled(2),
                },
                576: {
                    perView: 1,
                },
            },
            type: 'carousel',
            gap: 0,
            // rewind: false,
        });

        productSlider.on(['resize', 'mount.before'], () => {
            toggleArrows();
        });

        productSlider.mount();
    });
}
